import {
  Box,
  Center,
  Flex,
  HStack,
  Image,
  Text,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import GCPImage from "components/GCPImage";
import { carVersionI18n } from "lib/cars";
import { useTranslation } from "next-i18next";
import { F } from "ramda";
import StationListModal from "./StationListModal";
import { useMemo, useState } from "react";
import { CAR_INFO } from "lib/cars";
import MainButton from "components/MainButton";
import appStore from "store";
import { useRouter } from "next/router";

const CarList = ({ carData }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCarData, setSelectedCarData] = useState(null);

  const onClose = () => {
    setIsOpen(false);
  };

  const specialModel = useMemo(() => {
    return router.query.model ? router.query.model : null;
  }, [router.query.model]);

  if (Object.keys(carData).length === 0)
    return (
      <Flex
        flexDir="column"
        justify="center"
        align="center"
        h="calc(100% - 52px)"
        flexShrink={1}
        flex="1"
        w="100%"
      >
        <GCPImage src="/images/icons/station_nocar.png" alt="noCar" w="210px" />
        <Text
          mt="24px"
          color="rgba(51, 51, 51, 1)"
          fontSize="24px"
          fontWeight="700"
          lineHeight="35px"
        >
          {t("noCar")}
        </Text>
        <Text
          mt="8px"
          color="rgba(136, 136, 136, 1)"
          fontSize="14px"
          fontWeight="500"
          lineHeight="20px"
        >
          {t("noCarTip")}
        </Text>

        {/* 如果 colorSelected 物件裡有選項是 true 才顯示 MainButton */}
        {/* {Object.values(colorSelected).includes(true) && (
                <MainButton
                  mt="20px"
                  ml="16px"
                  fontSize="14px"
                  lineHeight="1"
                  onClick={() => {
                    appStore.colorSelected = {
                      white: false,
                      black: false,
                      red: false,
                      silver: false,
                      pink: false,
                      quick_silver: false,
                      blue: false,
                      sky_blue: false,
                    };
                  }}
                >
                  {t("noCarClean")}
                </MainButton>
              )} */}
      </Flex>
    );

  return (
    <Box>
      <StationListModal
        isOpen={isOpen}
        onClose={onClose}
        selectedCarData={selectedCarData}
      />
      {Object.keys(carData).map((car) => {
        // 先取得該車款的第一個站點數據
        const stationData = carData[car];
        // 取得該站點的第一個車型數據
        const firstStationKey = Object.keys(stationData)[0];
        const firstCarData = stationData[firstStationKey][0];

        let title = `${firstCarData.brand} ${firstCarData.model_name}`;
        let subTitle = carVersionI18n(firstCarData.version, t) || "";

        // 從 stationData 中計算 Object.values(stationData) 有多少不重複的 price
        const priceTypeCount = new Set(
          Object.values(stationData).flatMap((station) =>
            station.map((car) => car.price)
          )
        ).size;

        // 取得價格最低的 car
        const lowestPriceCar = Object.values(stationData)
          .flatMap((station) => station.map((car) => car.price))
          .reduce(
            (min, car) => (car.price < min.price ? car : min),
            stationData[firstStationKey][0]
          );

        return (
          <Flex key={car} w="100%">
            <Flex
              flexDir={{ base: "column", lg: "row" }}
              h={{
                base: "auto",
                lg:
                  specialModel &&
                  `${firstCarData.brand.toLowerCase()}-${firstCarData.model_name.replace(/\s/g, "").toLowerCase()}${firstCarData.version ? `-${firstCarData.version.replace(/\s/g, "").toLowerCase()}` : ""}` ===
                    specialModel.replace(/\s/g, "")
                    ? "184px"
                    : "160px",
              }}
              w="100%"
              bg="#F3F4F9"
              borderRadius="16px"
              p="16px"
              mb="16px"
              alignItems="center"
              justifyContent="space-between"
              cursor="pointer"
              onClick={() => {
                setSelectedCarData(carData[car]);
                setIsOpen(true);
              }}
              border={
                specialModel &&
                `${firstCarData.brand.toLowerCase()}-${firstCarData.model_name.replace(/\s/g, "").toLowerCase()}${firstCarData.version ? `-${firstCarData.version.replace(/\s/g, "").toLowerCase()}` : ""}` ===
                  specialModel.replace(/\s/g, "")
                  ? "2px solid #000000"
                  : "0px"
              }
              pt={
                specialModel &&
                `${firstCarData.brand.toLowerCase()}-${firstCarData.model_name.replace(/\s/g, "").toLowerCase()}${firstCarData.version ? `-${firstCarData.version.replace(/\s/g, "").toLowerCase()}` : ""}` ===
                  specialModel.replace(/\s/g, "")
                  ? { base: "48px", lg: "40px" }
                  : "16px"
              }
              pos="relative"
              overflow="hidden"
            >
              {specialModel &&
                `${firstCarData.brand.toLowerCase()}-${firstCarData.model_name.replace(/\s/g, "").toLowerCase()}${firstCarData.version ? `-${firstCarData.version.replace(/\s/g, "").toLowerCase()}` : ""}` ===
                  specialModel.replace(/\s/g, "") && (
                  <Flex
                    pos="absolute"
                    top="0px"
                    left="0px"
                    w="100%"
                    h="31px"
                    bg="#000000"
                  >
                    <Text
                      mt="7px"
                      ml="16px"
                      textStyle="poppinsH14"
                      fontWeight="bold"
                      color="#FFFFFF"
                    >
                      {t("station_special_model")}
                    </Text>
                  </Flex>
                )}
              <Flex
                w={{ base: "100%", lg: "auto" }}
                alignItems={{ base: "start", lg: "center" }}
                mb={{ base: "8px", lg: "0px" }}
              >
                <Box display={{ base: "none", lg: "block" }} minW="200px">
                  <GCPImage
                    src={firstCarData.image + "?v=2"}
                    alt="car"
                    w="200px"
                    mr="16px"
                  />
                </Box>

                <Box w="100%">
                  {/* 平台優選、立即確認 */}
                  <Flex mb="8px" alignItems="center">
                    <Wrap>
                      {((firstCarData.model_name === "Model 3" &&
                        firstCarData.version === null) ||
                        (firstCarData.model_name === "Model Y" &&
                          firstCarData.version === "後驅") ||
                        (firstCarData.model_name === "Model S" &&
                          firstCarData.version === "New! Long Range")) && (
                        <WrapItem>
                          <Text
                            mr="8px"
                            textStyle="notoH12"
                            fontWeight="bold"
                            color="white"
                            bg="#333333"
                            px="8px"
                            py="4px"
                            borderRadius="12px"
                          >
                            {t("Station_carList_first")}
                          </Text>
                        </WrapItem>
                      )}
                      {firstCarData.owner_settings?.order_auto_cancel_type ===
                        "auto_confirm" && (
                        <WrapItem>
                          <Text
                            mr="8px"
                            textStyle="notoH12"
                            fontWeight="bold"
                            border="1px solid #333333"
                            color="#333333"
                            px="8px"
                            py="3px"
                            borderRadius="12px"
                          >
                            {t("Station_carList_check")}
                          </Text>
                        </WrapItem>
                      )}
                    </Wrap>
                  </Flex>

                  <Flex w="100%" justify="space-between" alignItems="center">
                    <Box>
                      <Text
                        fontFamily="Poppins"
                        fontSize={{ base: "16px", lg: "20px" }}
                        lineHeight={{ base: "24px", lg: "28px" }}
                        fontWeight="700"
                        color="#333333"
                        mb="2px"
                      >
                        {title}
                      </Text>

                      <Text fontSize="14px" lineHeight="20px" color="#333333">
                        {subTitle}
                      </Text>

                      <Wrap alignItems="center" mt="8px">
                        {CAR_INFO.map((item) => {
                          const value =
                            item.key.split(".").length === 2
                              ? item.key === "note.transmission"
                                ? t(firstCarData.note.transmission)
                                : firstCarData[item.key.split(".")[0]][
                                    item.key.split(".")[1]
                                  ]
                              : item.key === "vehicle_size_name"
                                ? t(
                                    `Station_filter_carType_${firstCarData.vehicle_size_name}`
                                  )
                                : firstCarData[item.key];

                          return (
                            <WrapItem key={item.key}>
                              <Flex alignItems="center" key={item.key}>
                                <GCPImage
                                  src={item.icon}
                                  alt="car"
                                  w="16px"
                                  mr="3px"
                                />
                                <Text
                                  fontSize="12px"
                                  lineHeight="16px"
                                  color="#748598"
                                  mr="12px"
                                >
                                  {value} {item.subKey && t(item.subKey)}
                                </Text>
                              </Flex>
                            </WrapItem>
                          );
                        })}
                      </Wrap>
                    </Box>
                    <Box>
                      <GCPImage
                        src={firstCarData.image + "?v=2"}
                        alt="car"
                        minW="120px"
                        maxW="120px"
                        display={{ base: "block", lg: "none" }}
                      />
                    </Box>
                  </Flex>
                </Box>
              </Flex>

              <Flex
                flexDir={{ base: "row", lg: "column" }}
                justify="space-between"
                alignItems={{ base: "center", lg: "flex-end" }}
                w={{ base: "100%", lg: "199px" }}
                h="100%"
                borderLeft={{ base: "0px", lg: "1px solid rgba(0, 0, 0, 0.1)" }}
                borderTop={{ base: "1px solid rgba(0, 0, 0, 0.1)", lg: "0px" }}
                pt={{ base: "10px", lg: "0px" }}
              >
                <Flex alignItems="center">
                  {lowestPriceCar.owner_settings?.logo_image_url && (
                    <Image
                      src={lowestPriceCar.owner_settings?.logo_image_url}
                      alt="car"
                      h="16px"
                      mr="8px"
                    />
                  )}
                  <Text textStyle="notoH14" fontWeight="bold" color="#333333">
                    {priceTypeCount >= 5
                      ? priceTypeCount + "+"
                      : priceTypeCount}{" "}
                  </Text>
                  <Text textStyle="notoP14" color="#333333">
                    {t("price")}
                  </Text>
                </Flex>

                <Text textStyle="poppinsH16" fontWeight="bold" color="#333333">
                  {t("startFrom")}
                  <br />
                  NT$ {lowestPriceCar.price} /{t("dayUp")}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        );
      })}
    </Box>
  );
};

export default CarList;
